module.exports = __webpack_public_path__ + "media/true-damage-giants-ft-becky-g-keke-palmer-soyeon-duckwrth-thutmose-league-of-legends.68f6528f.mp3";